import hasDesign from "../services/lib/has-design";
import {
  GET_REALISM,
  START,
  SUCCESS,
  TICK,
  FAIL
} from "../constants/action-types";
import {API_REALISM} from "../constants/api";
import {REALISM_POLL_TIME} from "../constants";
import {saveDesignRequest} from "./save-design";
import {toggleModal} from "./modal";
import Mediator from "../services/Mediator";
import trackEvent from "../../../utils/track-event";

const calculateProgress = (
  {views: receivedRealiscticViews},
  {
    product: {
      meta: {realistic_views: realisticViews}
    },
    designs
  }
) => {
  const mainRealiscticViews = realisticViews.filter((view) => !view.additional);
  const numberOfExpectedMainRealiscticViews = mainRealiscticViews.length;
  const hasProductAdditionalRealisticViews =
    numberOfExpectedMainRealiscticViews !== realisticViews.length;
  if (!hasProductAdditionalRealisticViews) {
    return Math.round(
      (receivedRealiscticViews.large.filter((view) => !!view).length /
        numberOfExpectedMainRealiscticViews) *
        100
    );
  }
  const additionalRealisticViews = realisticViews.filter(
    (view) => view.additional
  );
  const numberOfExpectedAdditionalRealiscticViews = additionalRealisticViews.reduce(
    (acc, view) => {
      return view.required_design_defs.every((designDefs) => {
        let result = false;
        for (const key in designs) {
          if (designs.hasOwnProperty(key)) {
            const art = designs[key];
            if (art.name === designDefs.name && hasDesign(art.design)) {
              result = true;
            }
          }
        }
        return result;
      })
        ? acc + 1
        : acc;
    },
    0
  );
  return Math.round(
    (receivedRealiscticViews.large.filter((view) => !!view).length /
      (numberOfExpectedMainRealiscticViews +
        numberOfExpectedAdditionalRealiscticViews)) *
      100
  );
};

let realismInterval;

export const realismRequest = (productId, dispatch, getState) => {
  resetGettingRealism();
  dispatch({
    type: GET_REALISM + START
  });
  realismInterval = setInterval(() => {
    fetch(`${API_REALISM}/${productId}`, {
      headers: {
        "Accept": `application/json`,
        "Content-Type": `application/json`
      },
      credentials: `same-origin`
    })
      .then((res) => {
        if (res.status >= 400) {
          throw new Error(`Error`);
        }
        return res.json();
      })
      .then((res) => {
        const progress = calculateProgress(res, getState());
        if (progress === 100) {
          resetGettingRealism();
          dispatch({
            type: GET_REALISM + SUCCESS,
            response: {
              ...res,
              progress
            }
          });
        } else {
          dispatch({
            type: GET_REALISM + TICK,
            response: {
              ...res,
              progress
            }
          });
        }
      })
      .catch((error) => {
        resetGettingRealism();
        dispatch({
          type: GET_REALISM + FAIL,
          error
        });
      });
  }, REALISM_POLL_TIME);
  // clear intervar after end time
  setTimeout(() => {
    clearInterval(realismInterval);
  }, 120000);
};

export const getRealism = () => {
  return (dispatch, getState) => {
    trackEvent({
      category: `Editor`,
      action: `Realistic View`
    });
    if (Mediator.isDesignSaved && getState().product.id) {
      dispatch(toggleModal(`realism`));
      realismRequest(getState().product.id, dispatch, getState);
    } else {
      saveDesignRequest(dispatch, getState).then((response) => {
        const productId = response.product.id;
        if (productId) {
          dispatch(toggleModal(`realism`));
          realismRequest(productId, dispatch, getState);
        }
      });
    }
  };
};

export const resetGettingRealism = () => {
  if (realismInterval) {
    clearInterval(realismInterval);
  }
};
